var DEFAULT_EL, DEFAULT_TRANSLATION_SCOPE;

DEFAULT_EL = '.limited-time > .counter li.countdown-timer';

DEFAULT_TRANSLATION_SCOPE = 'js.modules.groupon-deal-timer';

if (window.CountdownTimer == null) {
  window.CountdownTimer = {};
}

CountdownTimer.View = Backbone.View.extend({
  UPDATE_FREQUENCY_MS: 1000,
  initialize: function() {
    this.i18n = this.options.i18n;
    this.el = this.options.el || DEFAULT_EL;
    return this.translationScope = this.options.translationScope || DEFAULT_TRANSLATION_SCOPE;
  },
  render: function() {
    if (this.interval != null) {
      clearInterval(this.interval);
    }
    this.$el = $(this.el);
    return this.interval = setInterval(((function(_this) {
      return function() {
        return _this.updateCountdown();
      };
    })(this)), this.UPDATE_FREQUENCY_MS);
  },
  updateCountdown: function() {
    var countdownTime, timeLeft;
    timeLeft = this.model.timeLeft();
    countdownTime = this.t("" + this.translationScope + (CountdownTimer.Helpers.countdownTimeKey(timeLeft, true)), {
      days: timeLeft.days,
      timerIcon: '<span class="icon-now"></span>',
      timestamp: CountdownTimer.Helpers.countdownTimestamp(timeLeft)
    });
    return this.$el.html(countdownTime);
  },
  t: function() {
    return this.i18n.t.apply(this.i18n, arguments);
  }
});

//# sourceMappingURL=data:application/json;base64,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
